"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// eslint-disable-next-line import/prefer-default-export

var breakoutEvent = {
  onBreakoutMoveRequest: function onBreakoutMoveRequest(eventInfo, submitClientEvent) {
    breakoutEvent.postMoveCallAnalyzer('client.breakout-session.move.request', eventInfo, submitClientEvent);
  },
  onBreakoutMoveResponse: function onBreakoutMoveResponse(eventInfo, submitClientEvent) {
    breakoutEvent.postMoveCallAnalyzer('client.breakout-session.move.response', eventInfo, submitClientEvent);
  },
  onBreakoutJoinResponse: function onBreakoutJoinResponse(eventInfo, submitClientEvent) {
    breakoutEvent.postMoveCallAnalyzer('client.breakout-session.join.response', eventInfo, submitClientEvent);
  },
  postMoveCallAnalyzer: function postMoveCallAnalyzer(event, eventInfo, submitClientEvent) {
    var _eventInfo$meeting$me, _eventInfo$currentSes, _eventInfo$currentSes2;
    if (!(eventInfo !== null && eventInfo !== void 0 && eventInfo.breakoutMoveId) || !(eventInfo !== null && eventInfo !== void 0 && eventInfo.meeting)) {
      return;
    }
    if (!((_eventInfo$meeting$me = eventInfo.meeting.meetingInfo) !== null && _eventInfo$meeting$me !== void 0 && _eventInfo$meeting$me.enableConvergedArchitecture)) {
      return;
    }
    submitClientEvent({
      name: event,
      payload: {
        identifiers: {
          breakoutMoveId: eventInfo.breakoutMoveId,
          breakoutSessionId: eventInfo === null || eventInfo === void 0 ? void 0 : (_eventInfo$currentSes = eventInfo.currentSession) === null || _eventInfo$currentSes === void 0 ? void 0 : _eventInfo$currentSes.sessionId,
          breakoutGroupId: eventInfo === null || eventInfo === void 0 ? void 0 : (_eventInfo$currentSes2 = eventInfo.currentSession) === null || _eventInfo$currentSes2 === void 0 ? void 0 : _eventInfo$currentSes2.groupId
        }
      },
      options: {
        meetingId: eventInfo.meeting.id
      }
    });
  }
};
var _default = exports.default = breakoutEvent;
//# sourceMappingURL=events.js.map
